import React, { useEffect, useState, useRef, useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import InputMask from "react-input-mask";
import CurrencyInput from "react-currency-input";
import { URLBunge } from "./Componentes/Config";
import {
  LogAcesso,
  AlertForm,
  AlertRedirect,
  MascaraCNPJ,
} from "./Componentes/Funcoes";
import CabecalhoPagina from "./Componentes/Cabecalho";
import Carregando from "./Componentes/Carregando";
import MenuPrinc from "./Componentes/MenuPrinc";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

import {
  Clear,
  BackgroundImg,
  TitNoticias,
  ColunaRegras,
  BtVoltar,
  TextoExplicacaoCasinha,
  ListaFiltroMes,
  BtFiltroMesAtivo,
  BtFiltroMes,
  LinhaResultadoFornada,
  DataAtualizacaoFornada,
  BtVerRelatorioCompleto,
  ItemListaBusca,
  BgModal,
  ModalEvento,
} from "./Estilos";

import IcoBusca from "./Images/ico_search_branco.png";
import ImgBtSetaVoltar from "./Images/BtSeta.png";

function AcademiaBunge(props) {
  const history = useHistory();
  const [Loading, setLoading] = useState(false);
  const { register, handleSubmit, errors, control, setValue } = useForm();

  const [NomeEvento, setNomeEvento] = useState("Minha Bunge Vendas");
  const [Token, setToken] = useState(localStorage.getItem("c_token"));
  const [IdUser, setIdUser] = useState(localStorage.getItem("id_tb_user"));
  const [CPFUser, setCPFUser] = useState(localStorage.getItem("c_cpf"));

  useEffect(() => {
    if (Token === null) {
      history.push({ pathname: "/", state: {} });
    } else {
      LogAcesso(Token, "Academia Bunge");
    }
  }, []);

  const [NumClientesTreinados, setNumClientesTreinados] = useState(0);
  const [NumClientesCompraram, setNumClientesCompraram] = useState(0);

  const [DataAtualizacao, setDataAtualizacao] = useState(0);
  const [MensagemBack, setMensagemBack] = useState("");
  const [ExisteDados, setExisteDados] = useState(false);

  function BuscaDadosFornada(mesSelecionado, anoSelecionado) {
    var d = new Date();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${URLBunge}/api/Indicadores/ListarTreinamentoAcademia`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result)
        if (result.sucesso === true) {
          setNumClientesTreinados(result.clientesTreinados);
          setNumClientesCompraram(result.clientesCompraram);

          setExisteDados(result.sucesso);
          setCarregandoResultado(false);
        } else {
          setExisteDados(result.sucesso);
          setMensagemBack(result.mensagem);
          setCarregandoResultado(false);
        }
      })
      .catch((error) => console.log("error", error));
  }

  function MostraDataAtualizacao() {
    var dia = DataAtualizacao.substr(8, 2);
    var mes = DataAtualizacao.substr(5, 2);
    var ano = DataAtualizacao.substr(0, 4);
    return (
      <>
        {dia}/{mes}/{ano}
      </>
    );
  }

  const [MesesAno, setMesesAno] = useState([]);

  useEffect(() => {
    var d = new Date();
    var dia = d.getDate();
    var mes = d.getMonth() + 1;
    var ano = d.getFullYear();
    var ano2 = d.getFullYear().toString().substr(-2);

    var startDate = "6-21";
    var month = parseInt(startDate.split("-")[0]);
    var year = parseInt(startDate.split("-")[1]);

    while (!(year === Number(ano2) && month === mes)) {
      if (month < 12) {
        month++;
      } else {
        month = 1;
        year++;
      }
      var MesAno;
      if (month == 1) {
        MesAno = "JAN";
      }
      if (month == 2) {
        MesAno = "FEV";
      }
      if (month == 3) {
        MesAno = "MAR";
      }
      if (month == 4) {
        MesAno = "ABR";
      }
      if (month == 5) {
        MesAno = "MAI";
      }
      if (month == 6) {
        MesAno = "JUN";
      }
      if (month == 7) {
        MesAno = "JUL";
      }
      if (month == 8) {
        MesAno = "AGO";
      }
      if (month == 9) {
        MesAno = "SET";
      }
      if (month == 10) {
        MesAno = "OUT";
      }
      if (month == 11) {
        MesAno = "NOV";
      }
      if (month == 12) {
        MesAno = "DEZ";
      }

      MesesAno.push({
        id: month + "20" + year,
        Mes: MesAno,
        Ano: "20" + year,
      });
    }

    // console.log(MesesAno);

    BuscaDadosFornada(mes, ano);
  }, []);

  useEffect(() => {
    setMesSelecionado(MesesAno[MesesAno.length - 1].id);
  }, [MesesAno]);

  const BtMes = (item) =>
    MesSelecionado == item.id ? (
      <BtFiltroMesAtivo>
        {item.Mes}
        <span>{item.Ano}</span>
      </BtFiltroMesAtivo>
    ) : (
      <BtFiltroMes onClick={() => SelecionaMes(item.Mes, item.Ano, item.id)}>
        {item.Mes}
        <span>{item.Ano}</span>
      </BtFiltroMes>
    );

  const [TipoSelecionado, setTipoSelecionado] = useState(0);
  const [MesSelecionado, setMesSelecionado] = useState();

  function SelecionaMes(Mes, Ano, Id) {
    setMesSelecionado(Id);

    var MesAno = 0;
    if (Mes == "JAN") {
      MesAno = 1;
    }
    if (Mes == "FEV") {
      MesAno = 2;
    }
    if (Mes == "MAR") {
      MesAno = 3;
    }
    if (Mes == "ABR") {
      MesAno = 4;
    }
    if (Mes == "MAI") {
      MesAno = 5;
    }
    if (Mes == "JUN") {
      MesAno = 6;
    }
    if (Mes == "JUL") {
      MesAno = 7;
    }
    if (Mes == "AGO") {
      MesAno = 8;
    }
    if (Mes == "SET") {
      MesAno = 9;
    }
    if (Mes == "OUT") {
      MesAno = 10;
    }
    if (Mes == "NOV") {
      MesAno = 11;
    }
    if (Mes == "DEZ") {
      MesAno = 12;
    }

    // console.log(MesAno + ' - ' + Ano);

    BuscaDadosFornada(MesAno, Ano);
  }

  const [CarregandoResultado, setCarregandoResultado] = useState(true);
  function LoadResultado() {
    return (
      <>
        <div>Carregando...</div>
      </>
    );
  }

  function FecharRelatorio() {
    setRelatorioMostra(false);
    setCarregandoBusca(true);
    setDadosRelatorioFlatlist([]);
  }

  const [RelatorioMostra, setRelatorioMostra] = useState(false);
  const [CarregandoBusca, setCarregandoBusca] = useState(true);
  const [DadosRelatorioFlatlist, setDadosRelatorioFlatlist] = useState([]);

  function MostraRelatorioDetalhado() {
    setRelatorioMostra(true);

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "bearer " + Token);

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(
      `${URLBunge}/api/Indicadores/ListarTreinamentoAcademiaDetalhado`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        console.log(result);
        setDadosRelatorioFlatlist(result.detalhes);
        setCarregandoBusca(false);
      })
      .catch((error) => console.log("error", error));
  }

  const renderItem = (item, index) => (
    <ItemListaBusca key={index} style={{ cursor: "default" }}>
      <div className={"NomeCliente"}>{item.razaoSocial}</div>
      <div className={"CNPJSAP"}>
        <span style={{ width: "auto", marginRight: 5 }}>CPNJ</span>{" "}
        {MascaraCNPJ(item.cnpj)}
      </div>
      <div className={"CNPJSAP"}>
        <span style={{ width: "auto", marginRight: 5 }}>
          Converteu em compra?
        </span>{" "}
        {item.converteuCompra}
      </div>
    </ItemListaBusca>
  );

  function RelatorioDetalhado(props) {
    return (
      <>
        <BgModal>
          <ModalEvento>
            <div className={"TituloEvento"}>Relatório detalhado</div>
            <Clear />
            <div className={"ListaClientes"} style={{ textAlign: "left" }}>
              <>
                {CarregandoBusca == true ? (
                  <LoadResultado />
                ) : DadosRelatorioFlatlist.length > 0 ? (
                  DadosRelatorioFlatlist.map((item, index) => {
                    return renderItem(item, index);
                  })
                ) : (
                  <div>
                    Nenhum cliente encontrado{"\n"}Verifique sua busca e tente
                    novamente.
                  </div>
                )}
              </>
            </div>
            <a className={"BtFecharModal"} onClick={() => FecharRelatorio()}>
              FECHAR
            </a>
          </ModalEvento>
        </BgModal>
      </>
    );
  }

  return (
    <>
      <CabecalhoPagina NomeEvento={NomeEvento} />
      {Loading === true ? <Carregando /> : null}

      <BackgroundImg Background={""} BackgroundMob={""} bgcolor={"#FFFFFF"}>
        {RelatorioMostra == true ? <RelatorioDetalhado /> : null}

        <ColunaRegras>
          <div className={"AreaColunaRegras"}>
            <TitNoticias>Academia Bunge</TitNoticias>
            <Clear />

            <BtVoltar
              onClick={() => history.push({ pathname: "/home", state: {} })}
              style={{ marginLeft: "auto", marginRight: "auto" }}
            >
              <img src={ImgBtSetaVoltar} /> <div>VOLTAR</div>
            </BtVoltar>
            <Clear />

            <br />

            {CarregandoResultado == true ? (
              <LoadResultado />
            ) : (
              <>
                <LinhaResultadoFornada>
                  <div>Clientes treinados</div>
                  <div>{NumClientesTreinados}</div>
                </LinhaResultadoFornada>

                <LinhaResultadoFornada>
                  <div>Clientes que compraram pós treinamento</div>
                  <div>{NumClientesCompraram}</div>
                </LinhaResultadoFornada>

                <BtVerRelatorioCompleto
                  onClick={() => MostraRelatorioDetalhado()}
                >
                  {" "}
                  <InfoOutlinedIcon /> <div>Ver relatório detalhado</div>
                </BtVerRelatorioCompleto>
              </>
            )}

            <TextoExplicacaoCasinha>
              Cada cliente convertido a vendas pós treinamento vale 2 moedas.
            </TextoExplicacaoCasinha>
            <BtVerRelatorioCompleto
              onClick={() =>
                history.push({
                  pathname: "/AcademiaFormularioListaRequisicoes",
                  state: {},
                })
              }
            >
              <div>Requisições de Atendimento</div>
            </BtVerRelatorioCompleto>
          </div>
        </ColunaRegras>

        <MenuPrinc Pagina="Pesquisas" />
      </BackgroundImg>
    </>
  );
}

export default AcademiaBunge;
